export const NOTIFICATION_VARIANT = {
  success: 'success',
  error: 'error',
  warning: 'warning',
  default: 'default',
};
